<script>
    import { onMount } from "svelte";
    import { API_URL } from "./Var.svelte"

    let data = [];
    const api_host = API_URL

    async function fetchData() {
    let url = `${api_host}/playing`;
        const response = await fetch(url);
        data = await response.json();
    }

    onMount(() => {
    
    const interval = setInterval(fetchData, 5000);
    fetchData();

    return () => clearInterval(interval);
  });
</script>

<div class="outer">
    <div class="inner">
        {#if (data.timestamp)}
        <img src={data.item.album.images[0].url} alt={data.item.album.name}>
        <span>{data.item.name} - {data.item.artists[0].name}</span>
        {:else}
        <img src="Spinner-1.5s-277px.svg" alt=album_cover>
        <span>Nothing playing right now...</span>
        {/if}
    </div>
</div>

<style>

    .outer  {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 2em;
    }

    .inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #191414;
        color: aliceblue;
        padding: 2em;
        padding-bottom: 0;
        box-shadow: 3px 3px 10px #888888;
        border-radius: 1em;
        width: 240px;

    }

    img {
        width: 240px;
    }

    .inner span {
        padding: 2em;
    }

</style>